import { useCallback } from "react";

export const useReceiverCol = () => {
  const getReceiverCol = useCallback(
    (record: any, isSchedule: boolean): string => {
      if (!isSchedule) {
        return record.receiverName;
      } else {
        return record.scheduledRecipients
          .map((item: any) => item.receiverName || item.email)
          .join("; ");
      }
    },
    []
  );

  return { getReceiverCol };
};
